<template>
  <v-main class="primary">
    <transition name="fade" mode="out-in">
      <loader-component v-if="loading"></loader-component>
      <router-view v-else></router-view>
    </transition>
  </v-main>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import LoaderComponent from '../../components/LoaderComponent.vue'
import { MODULOS } from '@/perfiles'

export default {
  components: {
    LoaderComponent,
  },

  async created() {
    this.ENABLE_LOADER()
    this.setThemeByModule(MODULOS.PROFESIONALIZACION)
    await Promise.all([
      this.fetchPreaspirantes(),
      this.fetchCandidatos(),
      this.fetchAspirantes(),
      this.fetchCursos(),
      this.fetchCapacitadores(),
      this.fetchCursosProgramados(),
      this.fetchCursosAsignados(),
      this.fetchEstatusCurso(),
      this.fetchEstatusCursoPersonal(),
      this.fetchCategoriasCatalogo(),
      this.fetchSugerenciaCursos(),
      this.fetchMunicipios(),
      this.fetchEstados(),
      this.fetchEstadoCivil(),
      this.fetchTipoNacionalidad(),
      this.fetchSexo(),
      this.fetchGrupoSanguineo(),
      this.fetchFrecuenciaRespetoPrincipio(),
    ])
    this.DISABLE_LOADER()
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
    }),
  },

  methods: {
    ...mapActions('capacitador', ['fetchCapacitadores']),
    ...mapActions('curso', ['fetchCursos']),
    ...mapActions('cursoProgramado', ['fetchCursosProgramados']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignados']),
    ...mapActions('estatusCurso', ['fetchEstatusCurso']),
    ...mapActions('estatusCursoPersonal', ['fetchEstatusCursoPersonal']),
    ...mapActions('capacitaciones', { fetchCategoriasCatalogo: 'fetchCategorias' }),
    ...mapActions('personal', ['fetchPersonal']),
    ...mapActions('preaspirante', ['fetchPreaspirantes', 'fetchAspirantes']),
    ...mapActions('candidato', ['fetchCandidatos']),
    ...mapActions('sugerenciaCursos', ['fetchSugerenciaCursos']),
    ...mapActions('frecuenciaRespetoPrincipio', ['fetchFrecuenciaRespetoPrincipio']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
    ...mapActions('estado', ['fetchEstados']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
  },
}
</script>
